import { BinaryReader } from 'Loader/serialization/common/BinaryReader';

export type HeaderSchema = {
    version: number;
    sensorCount: number;
    simKind: number;
    resultNumber: number;
    simNames: string[];
};

abstract class Serializable<PreviousSchema, LatestSchema> {
    constructor() {}

    private readHeader(reader: BinaryReader): HeaderSchema {
        reader.readUInt32(); // vMajor
        reader.readUInt32(); // vMinor
        const version = reader.readUInt32();

        const sensorCount = reader.readUInt32();
        const simKind = reader.readUInt32();
        const resultNumber = reader.readUInt8();
        const simNames: string[] = [];
        for (let s = 0; s < resultNumber; s++) {
            simNames[s] = reader.readString();
        }

        reader.readInt8(); // Chunk id
        reader.readInt32(); // Chunk size
        return { version, sensorCount, simKind, resultNumber, simNames };
    }

    protected abstract migrateToLatest(anyPrevious: PreviousSchema): LatestSchema;

    public deserialize(data: ArrayBuffer): LatestSchema {
        const reader = new BinaryReader(data);

        const header = this.readHeader(reader);
        return this.deserializeContent(header, reader);
    }

    protected abstract deserializeContent(header: HeaderSchema, reader: BinaryReader): LatestSchema;
}

export default Serializable;
